module.exports = __webpack_public_path__ + "static/media/flag-normal.aac98999.svg";